import React from 'react';
import Helmet from 'react-helmet';

import Layout from '../components/layout';
import StoryItem from '../components/StoryItem';
import Sharing from '../components/Sharing';

import mainPageStyles from '../css/mainPage.module.css';

import Nastasia from '../images/Nastasia.jpg';
import Sergei from '../images/Sergei.jpg';
import Alisa from '../images/Alisa.jpg';
import Mich from '../images/Mich.jpg';
import Gerda from '../images/Gerda.jpg';
import Ruslan from '../images/Ruslan.jpg';
import NastasiaTablet from '../images/Nastasia-tablet.jpg';
import SergeiTablet from '../images/Sergei-tablet.jpg';
import AlisaTablet from '../images/Alisa-tablet.jpg';
import MichTablet from '../images/Mich-tablet.jpg';
import GerdaTablet from '../images/Gerda-tablet.jpg';
import RuslanTablet from '../images/Ruslan-tablet.jpg';

import Adult from '../icons/Adult';

const ITEMS = [
  {
    imageSrc: {
      mobile: Nastasia,
      tablet: NastasiaTablet,
      desktop: NastasiaTablet,
    },
    link: '/nastasya',
    name: 'Настасья',
    bio: 'Актриса, 31 год',
    quote: <span>«Я связывала своих кукол и&nbsp;мастурбировала»</span>,
    duration: '112 секунд',
  },
  {
    imageSrc: {
      mobile: Mich,
      tablet: MichTablet,
      desktop: MichTablet,
    },
    link: '/michael',
    name: 'Михаил',
    bio: 'Инженер, 27 лет',
    quote: '«Мне нравится насилие в порно, это остро»',
    duration: '200 секунд',
  },
  {
    imageSrc: {
      mobile: Alisa,
      tablet: AlisaTablet,
      desktop: AlisaTablet,
    },
    link: '/alisa',
    name: 'Алиса',
    bio: 'Автор украшений, 25 лет',
    quote: '«Обычного секса у меня не было никогда в жизни»',
    duration: '200 секунд',
  },
  {
    imageSrc: {
      mobile: Sergei,
      tablet: SergeiTablet,
      desktop: SergeiTablet,
    },
    link: '/sergei',
    name: 'Сергей',
    bio: 'Экономист, 32 года',
    quote: '«Видел, как девушку по кругу пускали»',
    duration: '169 секунд',
  },
  {
    imageSrc: {
      mobile: Gerda,
      tablet: GerdaTablet,
      desktop: GerdaTablet,
    },
    link: '/gerda',
    name: 'Герда',
    bio: 'Редактор, 35 лет',
    quote: '«Казалось, секс – это что-то страшное»',
    duration: '212 секунд',
  },
  {
    imageSrc: {
      mobile: Ruslan,
      tablet: RuslanTablet,
      desktop: RuslanTablet,
    },
    link: '/ruslan',
    name: 'Руслан',
    bio: 'Cвободный художник, 29 лет',
    quote: <span>«Гетеропорно я вообще не&nbsp;смотрю»</span>,
    duration: '201 секунда',
  },
];

const IndexPage = () => (
  <Layout>
    <main>
      <Helmet>
        <title>Главная</title>
      </Helmet>

      <div className={mainPageStyles.container}>
        <header className={mainPageStyles.header}>
          <h1 className={mainPageStyles.title}>
            <div className={mainPageStyles.firstLetter}>
              <svg width="94" height="202" viewBox="0 0 94 202" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M.24 151.96c0 31.36 16.52 49.28 46.76 49.28s46.76-17.92 46.76-49.28v-35.84c0-28.84-11.48-44.8-34.16-44.8-13.72 0-23.24 6.16-28.56 17.36V52.84c0-18.76 6.16-24.08 17.08-24.08 9.8 0 15.96 5.32 15.96 19.32v7H93.2v-5.04C93.2 18.68 77.52.76 47.28.76 15.36.76.24 18.68.24 51.72v100.24zM47 99.32c9.8 0 15.96 5.32 15.96 19.32v35.28c0 14-6.16 19.04-15.96 19.04s-15.96-5.04-15.96-19.04v-35.28c0-14 6.16-19.32 15.96-19.32z" fill="#fff"/>
              </svg>
            </div>
            <div>
              откровенных историй людей, которые смотрят
              <span className={mainPageStyles.pinkText}> порно</span>
            </div>

            <div className={mainPageStyles.svg}>
              <Adult />
            </div>
          </h1>
        </header>

        <div className={mainPageStyles.list}>
          {ITEMS.map(item => (
            <StoryItem
              key={item.link}
              link={item.link}
              imageSrc={item.imageSrc}
              name={item.name}
              bio={item.bio}
              quote={item.quote}
              duration={item.duration}
            />
          ))}
        </div>

        <footer className={mainPageStyles.footer}>
          <div className={mainPageStyles.positions}>
            <div>
              <p className={mainPageStyles.position}>Автор текста и фото:</p>

              <p className={`${mainPageStyles.name} ${mainPageStyles.nameFirst}`}>
                Екатерина Дериглазова
              </p>
            </div>

            <div>
              <p className={mainPageStyles.position}>Редактор:</p>

              <p className={mainPageStyles.name}>Евгения Пашковская</p>
            </div>
          </div>

          <p className={mainPageStyles.notice}>
            Материал предназначен для лиц старше 18 лет.
            <br />
            Некоторые описанные практики могут быть небезопасны для здоровья.
          </p>
        </footer>

        <div className={mainPageStyles.sharing}>
          <Sharing />
        </div>
      </div>
    </main>
  </Layout>
);

export default IndexPage;
